/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Await_Filter_OptionInputs */

const vi_await_filter_option = /** @type {(inputs: Await_Filter_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chờ đóng gói`)
};

/**

* @param {Await_Filter_OptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const await_filter_option = /** @type {((inputs?: Await_Filter_OptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Await_Filter_OptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_await_filter_option(inputs)
});